<div class="form-group">
  <label for="prod-m">{{ 'form.products'| translate }}</label>
  <angular2-multiselect [data]="list"
      [(ngModel)]="productsSelected"
      [settings]="computedSettings"
      [disabled]="disabled"
      (onSelect)="onElementSelect()"
      (onSelectAll)="onElementSelect()"
      (onDeSelectAll)="onElementSelect()"
      (onFilterSelectAll)="onElementSelect()"
      (onFilterDeSelectAll)="onElementSelect()">
  </angular2-multiselect>
</div>